import { queryOptions } from '@tanstack/react-query'
import type { DashboardCard, DashboardClass, DashboardScope, DashboardView } from './dashboard'
import { apiGet } from './client'

/**
 * Tabloul de bord al UNUI MODUL - ce raspunde `App\Dashboard\ModuleBoard`.
 *
 * Aceleasi carduri ca pe tabloul central, deci si acelasi tip de card
 * (`DashboardCard` din `api/dashboard.ts`); ce lipseste fata de el sunt
 * tablele proprii, sfatul agentului si wallboardul - tabloul de modul nu le
 * avea nici in portal.
 *
 * Fisier separat de `api/dashboard.ts`: acela e al benzii de tablouri, care
 * spune raspicat ca nu serveste tablouri de modul.
 */
export interface ModuleDashboard {
  pageTitle: string
  lead: string
  boardUrl: string
  cards: DashboardCard[]
  tally: { read: number; unreadable: number }
  noCompany: boolean
  history: boolean
  board: { kind: string; key: string; view: string; override: number; edit: boolean }
  views: Record<string, DashboardView>
  classes: Record<string, DashboardClass>
  windows: Record<string, string>
  scope: DashboardScope
}

/**
 * Perspectiva, fereastra si clasa de active calatoresc in adresa, ca in portal.
 *
 * `module` intra in cheia de cache fiindca doua tablouri de modul cu aceeasi
 * cautare sunt doua raspunsuri diferite; `path` e capatul lui (nu se poate
 * ghici din nume - Inventoree are `/inventoree/board`, fiindca
 * `/inventoree/dashboard` e luat de tabloul AmCharts vechi).
 */
export function moduleDashboardQuery(module: string, path: string, search: string) {
  const q = search.startsWith('?') ? search : search ? `?${search}` : ''
  return queryOptions({
    queryKey: ['module-board', module, q],
    queryFn: () => apiGet<ModuleDashboard>(`${path}${q}`),
  })
}
